import { Box, Typography } from '@mui/material'
import moment from 'moment'
import { FC } from 'react'

// components import
import { CardBox } from '../../../theme/styleComponents'
import { BillTimeline as BillTimelineType } from '../../../../generated'

interface BillTimelineProps {
  title: string
  showPrebillView?: boolean
  billTimelines?: Pick<BillTimelineType, 'id' | 'description' | 'createdAt'>[] | null
}

const BillTimeline: FC<BillTimelineProps> = ({ title, billTimelines, showPrebillView = false }) => {
  return (
    <CardBox mb={3}>
      <Box
        sx={{
          p: 3,
          borderBottom: '1px solid #E4E7EC'
        }}
      >
        <Typography variant="h6" fontWeight={400} color="gray900" fontSize="18px">
          {title}
        </Typography>
      </Box>

      <Box sx={{ maxHeight: showPrebillView ? '260px' : '500px', overflowY: 'auto' }}>
        {billTimelines?.map(timeline => {
          return (
            <Box key={timeline.id} px={3.5} py={2} borderBottom="1px solid #E4E7EC">
              <Typography
                color="secondary.light"
                fontWeight={500}
                mb={1}
                dangerouslySetInnerHTML={{ __html: timeline.description }}
              />
              <Typography variant="subtitle1" color="secondary.light">
                {moment(parseInt(timeline.createdAt)).format('MMM DD, YYYY - h:mm A')}
              </Typography>
            </Box>
          )
        })}
      </Box>
    </CardBox>
  )
}

export default BillTimeline
